// Libraries
import React, { useEffect, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { Box, Typography, Alert } from '@mui/material';

// Local
import Warning from '../Warning';

const Abstract = ({ paper, highlighter }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isAbstractEmpty = (text) => {
      return !text || text.trim().length === 0;
    };

    if (!isAbstractEmpty(paper.Content?.Abstract)) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [paper.Content?.Abstract]);

  return show ? (
    <Box
      sx={{
        width: '100%',
        border: (theme) =>
          theme.palette.mode === 'dark'
            ? '1px solid #333333'
            : '1px solid #d4d4d4',
        padding: '10px',
        boxSizing: 'border-box',
        marginBottom: '10px',
      }}
    >
      <Typography
        variant="body1"
        sx={{
          textAlign: 'left',
          fontWeight: 'bold',
          marginBottom: '10px',
          width: '100%',
        }}
      >
        Abstract
      </Typography>
      <Alert
        severity="info"
        sx={{
          display: 'none',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        This paper&apos;s abstract is unstructured, therefore sentence
        similarity is unavailable for this portion of the text.
      </Alert>
      <Highlighter
        searchWords={highlighter.split(' ')}
        textToHighlight={paper.Content.Abstract}
        autoEscape={true}
      />
    </Box>
  ) : (
    <Warning section={'Abstract unavailable'} />
  );
};

export default Abstract;
